"use strict";
//Indonesian
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Memasukkan',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Keluaran',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Membatalkan',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Menyimpan',
  'BACK-BTN-LABEL': 'Kembali',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Bisu',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Memegang',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Keypad',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Transfer',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'New Panggilan',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Tutup Telepon',
  'CALLLIST-NOCALL' : 'Tidak ada Panggilan Aktif',
  'CANCEL-BTN-LABEL' : 'Membatalkan',
  'EMAIL-PLACEHOLDER' : 'Alamat email',
  'INCOMINGCALL-HEADER' : 'Panggilan masuk',
  'INCOMINGCALL-ACCEPT' : 'Menerima',
  'INCOMINGCALL-DECLINE' : 'Menurun',
  'INCOMINGCALL-VOICEMAIL' : 'Kirim ke Voicemail',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Masukkan alamat email',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'kata sandi',
  'LOGIN-CHECKBOX-LABEL' : 'Ingat Saya',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Lupa kata sandi?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Masuk',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Masukkan alamat email Anda untuk mereset password Anda.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Masukkan sandi lengkap',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Silakan masukkan email yang valid',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Silakan masukkan email yang valid',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'ulang',
  'LOGIN-RESETPW-INFO-TEXT' : ', Silakan mengubah sandi Anda. Password harus mengandung setidaknya satu huruf, tidak ada ruang putih, tidak mulai dengan @, dan 8 atau lebih karakter.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Kata sandi baru',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Ulangi kata kunci',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Perubahan',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'membatalkan',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Lihat Alerts',
  'SETTINGS-VERSION' : 'versi ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Dokumentasi bantuan',
  'SETTINGS-CHECKBOX-LABEL' : 'Memungkinkan',
  'SETTINGS-CHECKBOX-HEADER' : 'Selalu di atas?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Tutup Alerts',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Keluar',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Perpanjangan',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Ringtone',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Alat Input',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Perangkat Output',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Antarmuka Tema',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Antarmuka Bahasa',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Kembali',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Bersih',
  'CALLHISTORY-HEADER' : 'Sejarah',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Tidak ada Sejarah Panggilan',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Pengaturan',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'bersih',
  'ALERTLOG-HEADER' : 'Alerts',
  'ALERTLOG-NO-ALERT-MSG' : 'Tidak ada tanda tersedia',
  'UTILITIES-STATUS-ONHOLD' : 'Tertahan',
  'UTILITIES-STATUS-MUTED' : 'Meredam',
  'UTILITIES-STATUS-ACTIVE' : 'Aktif',
  'UTILITIES-STATUS-DIALING' : 'Panggilan',
  'ALERTITEM-HEADING-LOGIN' : 'Masuk',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Nama pengguna atau kata sandi yang Anda masukkan salah.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Kehilangan koneksi jaringan. Memeriksa status koneksi.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Masukkan nomor untuk panggilan',
  'CALLDETAILS-HOLD' : 'Tertahan',
  'CALLDETAILS-MUTED': 'Meredam',
  'CALLLIST-STATUS-ACTIVE': 'Aktif',
  'CALLLIST-STATUS-DIALING': 'panggilan',
  'CALLHISTORY-STATUS-FAILED': 'Gagal',
  'HEADING-STATUS-CONNECTED' : 'terhubung',
  'HEADING-STATUS-OFFLINE' : 'menjauh',
  'BLIND-BTN-LABEL': 'Buta',
  'ATTENDED-BTN-LABEL': 'dihadiri',
  'SOFTPHONE-DTMF-COMMANDS': "Masukkan Nomor",
  'ARIA-LOGIN-SIGNIN-BTN': "Masuk tombol di",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Tombol sandi Lupa",
  'ARIA-CANCEL-BTN': "tombol Batal",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "tombol reset password",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Tidak sekarang tombol",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Tombol kembali',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Tombol sejarah yang jelas',
  'ARIA-SETTINGS-LOGOUT-BTN': "tombol Keluar",
  'ARIA-SETTINGS-VIEWALERT-BTN': "Tombol View alert",
  'ARIA-SETTINGS-HELPDOC-BTN': "Bantuan tombol dokumentasi",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "Tombol Ubah password",
  'ARIA-BACKSPACE-BTN': 'tombol backspace',
  'ARIA-DIALING-INPUT-FIELD': 'field input panggilan',
  'ARIA-HEADER': 'Header',
  'ARIA-CLEAR-ALERTS-BUTTON': 'Tombol yang jelas alert',
  'ARIA-ALERT-LIST': 'daftar peringatan',
  'ARIA-CHECKBOX': 'kotak centang',
  'ARIA-SAVE-BTN': 'tombol save',
  'ARIA-INPUT-FIELD': 'Input field',
  'ARIA-INPUT': 'Memasukkan',
  'ARIA-KEYPAD': 'Keypad',
  'ARIA-KEY': 'Kunci',
  'ARIA-AUDIO-SLIDER': 'slider Audio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'kontrol slider Audio',
  'ARIA-MENU-ITEM': 'Menu item',
  'ARIA-DROP-DOWN-MENU': 'Drop down menu',
  'ARIA-BADGE-BUTTON': 'lencana tombol',
  'ARIA-CALL-DETAIL': 'rinci panggilan',
  'ARIA-OPEN-SETTINGS-BUTTON': 'tombol pengaturan terbuka',
  'UPDATE-HEADER': 'Pembaruan tersedia',
  'UPDATE-MSG': 'Apakah Anda ingin me-restart aplikasi sekarang?',
  'UPDATE-POSTPONE-BUTTON': 'Tunda (1 Min)',
  'UPDATE-UPDATE-BUTTON': 'Memperbarui',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'tunda Tombol',
  'ARIA-UPDATE-UPDATE-BUTTON': 'Update Tombol',
  'ACTIVECALL-STATUS-RINGING': 'dering',
  'ACTIVECALL-STATUS-ACTIVE': 'Aktif',
  'ACTIVECALL-STATUS-DIALING': 'panggilan',
  'ACTIVECALL-STATUS-FAILED': 'Gagal',
  'LOGIN-INPUT-SHOW': 'Menunjukkan',
  'LOGIN-INPUT-HIDE': 'Menyembunyikan',
  'CALLHISTORY-TODAY': 'Hari ini',
  'CALLHISTORY-YESTERDAY': 'Kemarin',
  'ALERT_FORGOT_PASSWORD': 'Lupa kata sandi',
  'ALERT_SETTINGS_WILL_APPLY': 'panggilan aktif; Pengaturan akan berlaku saat idle.',
  'ALERT_DIALING_OPTIONS': 'panggilan Pilihan',
  'ALERT_DIALING_OPTIONS_BODY': 'Hilang Pilihan sambung',
  'ALERT_LOGIN': 'Masuk',
  'ALERT_SOFTPHONE_EXTENSION': 'Tidak ada ekstensi softphone',
  'ALERT_MORE_INFORMATION': 'Untuk informasi lebih lanjut kunjungi:',
  'ALERT_LOST_CONNECTION': 'Kehilangan koneksi jaringan. Memeriksa status koneksi.',
  'ARIA-PLAY-BTN': 'tombol putar',
  'ARIA-STOP-BTN': 'tombol stop',
  'CONTACTS-STATUS-ONLINE': 'Online',
  'CONTACTS-STATUS-OFFLINE': 'Offline',
  'CONTACTS-STATUS-BUSY': 'Busy',
  'CONTACTS-STATUS-UNKNOWN': 'tidak diketahui',
  'LABELLEDINPUT-LABEL-EMAIL': "Alamat email",
  'LABELLEDINPUT-LABEL-PASSWORD': "Kata sandi",
  'LABELLEDINPUT-LABEL-TEXT': "Teks",
  'LABELLEDINPUT-HINT-EMAIL': "Masukkan alamat email yang valid di bawah ini.",
  'LABELLEDINPUT-HINT-PASSWORD': "Masukkan password yang valid bawah.",
  'LABELLEDINPUT-HINT-TEXT': "Masukkan teks di bawah.",
  'ARIA-ICON-AREA': 'icon Lokasi',
  'SETTINGS-ADVANCED-LOGGING': "Penebangan maju",
  'APPMENU-SETTINGS-BTN-LABEL': "Buka Pengaturan",
  'APPMENU-HELP-BTN-LABEL': "Dokumentasi bantuan",
  'APPMENU-LOGOUT-BTN-LABEL': "Keluar",
  'APPMENU-VERSION': "versi ",
  'HEADER-SETTINGS-TITLE': "Pengaturan",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Pemberitahuan",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Penampilan",
  'SETTINGS-CONTACTS-BTN-LABEL': "Kontak",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Penyelesaian masalah",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Sesuaikan bagaimana Anda menerima update.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Ubah tampilan dan nuansa aplikasi.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Impor kontak Anda",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Alat untuk membantu Anda mengetahui apa yang salah",
  'ARIA-BACK-BTN-LABEL': "Kembali",
  'HEADER-BACK-ARIA-LABEL' : 'kembali',
  'ENTITYLIST-SEARCH-FOUND': "ditemukan.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "items",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Grup baru',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Tidak ada kontak yang ditemukan',
  'ENTITYLIST-TRY-IMPORTING': 'Cobalah mengimpor atau menambahkan kontak.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Impor',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Masukkan nomor untuk mengirim atau mengimpor daftar kontak Anda di dalam setting.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Cari kontak",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Tambahkan nomor',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Tidak ada informasi kontak',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Tambahkan nomor untuk memulai',
  'ARIA-CARD-DETAILS-EDIT': 'Edit',
  'ARIA-CARD-DETAILS-DELETE': 'Menghapus',
  'SETTINGS-DEVICES-BTN-LABEL': "Perangkat",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Ubah cara perangkat Anda dikonfigurasi.",
  'HEADER-CONTACTS-ARIA-LABEL' : "kontak",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Penyelesaian masalah",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Aktifkan logging lanjutan",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Bila diaktifkan, aplikasi akan membuat log lanjutan untuk membantu mendiagnosis kesalahan aplikasi.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Advanced Logging',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Peringatan",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Lihat Lansiran",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Akses catatan peringatan dan log.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Nada dering",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Mengubah nada dering untuk panggilan suara masuk.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Default",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Cahaya",
  'APPMENU-DARK-THEME-BTN-LABEL': "Gelap",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Selalu di atas",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Bila diaktifkan maka aplikasi akan selalu tampil diatas aplikasi yang lain.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Selalu di atas?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Tema",
  'SETTINGS-THEMES-DESCRIPTION': "Tema mengubah keseluruhan tampilan aplikasi.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Bahasa",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Mengubah bahasa mengubahnya selama aplikasi berlangsung.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Alat",
  'SETTINGS-CATEGORY-HEADER-CONTACTS': "Kontak",
  'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Penampilan",
  'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Pemberitahuan",
  'SETTINGS-INPUT-DEVICE-TITLE': "Alat input",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Atur perangkat audio yang ingin Anda gunakan untuk input.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Perangkat Output",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Atur perangkat audio yang ingin Anda gunakan untuk output.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Impor kontak Anda",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Pilih opsi Anda di bawah ini untuk mengimpor kontak.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Contoh CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Menekan tombol di bawah ini akan mendownload contoh file CSV.",
  'SETTINGS-CONTACTS-BACKUP': 'Backup',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Menekan tombol di bawah ini akan mendownload cadangan CSV dari kontak Anda. Ini dianjurkan sebelum impor.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Download Sampel',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Impor",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Impor",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Download Backup',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Tambah kontak',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Membatalkan",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Delete",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Yakin ingin menghapus kontak ini?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Melengkapi tindakan ini akan menghapus informasi kontak saat ini secara permanen. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Bidang dalam bentuk di bawah ini memiliki kesalahan.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Informasi pribadi',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Nama depan',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Masukkan nama depan',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Nama keluarga',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Masukkan nama keluarga',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Perusahaan',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Masukkan Nama Perusahaan',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Nomor telepon',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Tambah Telepon',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Membatalkan',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Menyimpan',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Kontak baru',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Perbarui Kontak',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Bidang ini tidak boleh kosong.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Jumlah',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Masukkan angka 10 digit yang benar',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Masukkan nomor ...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Pilihan?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Rumah',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Bisnis',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobile',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Lain',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Label',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Pilih nomor yang akan dihubungi',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Pilihan',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Masukkan angka yang benar',
};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-id.js